import type { SinglePayment } from '../../../../services/SinglePayments';

type FromSinglePaymentPreviewProps = {
  nextStep: () => void;
  data: SinglePayment | null;
};

export const FormSinglePaymentPreview = (props: FromSinglePaymentPreviewProps) => {
  return (<>
      <div className=' flex items-center justify-center p-4'>
        <div className='w-full max-w-2xl'>
          <div className='shadow-sm bg-white border rounded-lg max-w-2xl w-full'>
            <div className='p-6 '>
              <div>
                <h2 className='font-bold text-2xl'>
                  Resumen de pago
                </h2>
              </div>
            </div>
            <div className='px-6'>
              <div data-orientation='horizontal' role='none' className='shrink-0 bg-gray-300 h-[1px] w-full'></div>
            </div>
            <div className='px-6 py-4 flex flex-col'>
              <h3 className='font-bold text-xl mb-4'>Resumen del Usuario</h3>
              <p className='text-gray-700'><strong>Nombre:</strong> {props.data?.user?.name} {props.data?.user?.lastname}</p>
              <p className='text-gray-700'><strong>Email:</strong> {props.data?.user?.email}</p>
              <p className='text-gray-700'><strong>Teléfono:</strong> {props.data?.user?.phone || 'Información no disponible'}</p>
              <p className='text-gray-700'><strong>Carrera: {props.data?.generation?.description}</strong></p>
              <h3 className='font-bold text-xl mt-6 mb-4'>Resumen del Pago</h3>
              <p className='text-gray-700'><strong>Monto:</strong> {props.data?.amount}</p>
              <p className='text-gray-700'><strong>Moneda:</strong> {props.data?.currency?.code}</p>
              <p className='text-gray-700'><strong>Numero de cuota:</strong> {props.data?.quote_number}/{props.data?.num_quotes}</p>
            </div>


            <div className='px-6 pb-6  flex flex-col'>
              <div className='flex flex-col items-end' />
              <div className='flex flex-col items-end'>
                <button
                  className='btn'
                  type='button'
                  onClick={props.nextStep}
                >
                  Continuar al pago
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
